module.exports = __webpack_public_path__ + "static/scribe-agency-a9a1909d2336a6062b6a68f723c0e8e4.png";